import { render, staticRenderFns } from "./Transfer_correct.vue?vue&type=template&id=efd513fc&scoped=true&"
import script from "./Transfer_correct.vue?vue&type=script&lang=js&"
export * from "./Transfer_correct.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_correct.vue?vue&type=style&index=0&id=efd513fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd513fc",
  null
  
)

export default component.exports